import type { TextColor } from '../types';

export const COLOR_TABLE: Record<TextColor, string> = {
    White: '#fff',
    'Dark Grey': '#131313',
    'Dark Grey w/ Red': '#DD2834',
    Red: '#DD2834',
};
